(function($){
    $('body').on('click', '.disabled.wc-variation-selection-needed', function(e){
        e.preventDefault();
    })
    $('.shipping-toggle input').on('click', function(){
        toggle_shipping($(this));
    });
    $(document).ready(function(){
        if($('#ship-to-different-address').length > 0){
            $('.shipping_address').removeAttr('style');
            toggle_shipping($('.shipping-toggle input'));
        }
    });
    if($('#coupon-removed').length > 0){
        window.history.pushState('page2', '', $('#coupon-removed').attr('data-checkout'));
        $('<div class="woocommerce-message" role="alert">Kupon został pomyślnie usunięty.</div>').insertAfter('.woocommerce-form-coupon-toggle');
    }

    function toggle_shipping(th){
        if(th.prop('checked') === false){
            $('.woocommerce-shipping-fields').fadeIn(500);
            $('#ship-to-different-address input').prop('checked', true);
        }
        else{
            console.log('jest false')
            $('.woocommerce-shipping-fields').fadeOut(500);
            $('#ship-to-different-address input').prop('checked', false);
        }
    }

    // $('body').on('click', '.payment_method_klarna_payments_pay_later', function(){
    //     var th = $(this);
    //     var int = setInterval(function(){
    //         if($('.blockUI').length > 0){
    //
    //         }
    //         else{
    //             clearInterval(int);
    //             // $('.wc_payment_method').each(function(){
    //             //     $(this).find('.input-radio').removeAttr('checked');
    //             // })
    //             // $('.payment_method_klarna_payments_pay_later').find('.input-radio').attr('checked', 'checked');
    //             // console.log('klclick8')
    //         }
    //     }, 10)
    //     setTimeout(function(){
    //         $('.wc_payment_method').each(function(){
    //             $(this).find('.input-radio').removeAttr('checked');
    //         })
    //         $('.payment_method_klarna_payments_pay_later').find('.input-radio').attr('checked', 'checked');
    //         console.log('klclick9')
    //     }, 5000)
    // })
    if($('.legia-biiling-fields').length > 0){
        setInterval(function(){
            $('.payment_box').each(function(){
                if($(this).is(':visible')){
                    $(this).closest('.wc_payment_method').find('.input-radio').attr('checked', 'checked');
                }
                else{
                    $(this).closest('.wc_payment_method').find('.input-radio').removeAttr('checked');
                }
            })
        }, 500)
    }

})(jQuery);